let key = null;

export const settoken = (newkey) => {
    key = newkey;
}

export const gettoken = () => {
    return key;
}